/*! globalize.js.js */
(function() {
    /**
     * Fake window object that permits interception of BPlayer call
     * @type {{BPlayer: artificialContext.BPlayer}}
     */
    const artificialContext = {
        BPlayer(asset, userOptions, callbacks) {
            const bmmrAsset = this.bmmrAsset || asset;
            userOptions.containerElement = this.containerElement;

            window.BPlayer(bmmrAsset, userOptions, callbacks);
        }
    };

    /**
     * Finds BPlayer legacy initialization constructs
     * @method
     * @returns {Node[]} script elements
     */
    function findLegacyConstructs() {
        const scripts = document.scripts;
        const matches = [];

        for (let i = scripts.length - 1, scriptElement; 0 <= i; i--) {
            scriptElement = scripts[i];
            const textContent = (scriptElement.text || scriptElement.textContent).trim();
            if (scriptElement.src && scriptElement.src.match(/bplayer.js/) && Boolean(textContent)) {
                matches.push(scriptElement);
            }
        }

        return matches;
    }

    /**
     * @method
     */
    function initialize() {
        const legacyConstructs = findLegacyConstructs();

        if (!legacyConstructs.length) {
            return;
        }

        /* eslint-disable no-console */
        if (console && console.warn) {
            console.warn("[BPlayer]", "You are using deprecated BPlayer initialization, please update!");
        }
        /* eslint-enable no-console */

        legacyConstructs.forEach(function(scriptElement) {
            const textContent = (scriptElement.text || scriptElement.textContent).trim();

            const wrapper = new Function(
                "window",
                "container",
                "bmmrAsset",
                `
          window.containerElement = container;
          window.bmmrAsset = bmmrAsset;

          ${ textContent }`);

            wrapper(artificialContext, scriptElement, window.bplayerAsset);
        });
    }

    if (window.BPlayer) {
        initialize();
    } else {
        window.addEventListener("BPlayerLoaded", initialize);
    }
})();
